import {
  AccumServiceType,
  AccumulatorVariant,
  EnrichedAccumItemType,
  UnlimitedAccumulatorButtonType,
} from 'types/accumulators';
import { elkPlanBUnlimAccum3HoursEnabled, isWithinThresholdFromNow } from 'utils';

import { getUnlimitedVariant } from './getUnlimitedVariant';

const getButtonVariantForBaseTariffs = ({
  accumulator,
  services,
  tetheringIsLow,
}: {
  accumulator: EnrichedAccumItemType;
  services: AccumServiceType | undefined;
  tetheringIsLow?: boolean;
}): UnlimitedAccumulatorButtonType | null => {
  const unlimitedVariant = getUnlimitedVariant({ accumulator, services, tetheringIsLow });
  const isElkUnlimAccum3HoursEnabled = elkPlanBUnlimAccum3HoursEnabled();

  if (unlimitedVariant === 'Unlimited24Hours') {
    const isNeedToShowButton =
      !!services?.unlimited24?.expirationDate &&
      isWithinThresholdFromNow({
        dateString: services?.unlimited24?.expirationDate,
        threshold: { minutes: 15 },
      });

    return isNeedToShowButton ? 'GbForDay' : null;
  }

  if (
    unlimitedVariant === 'UnlimitedWithLimitedTethering' ||
    unlimitedVariant === 'UnlimitedWithUnlimitedTethering'
  ) {
    return 'Tethering';
  }

  if (unlimitedVariant === 'Unlimited3HoursAvailable' && isElkUnlimAccum3HoursEnabled) {
    return 'Unlim3Available';
  }

  if (unlimitedVariant === 'Unlimited3HoursCooling' && isElkUnlimAccum3HoursEnabled) {
    return 'Unlim3Cooling';
  }

  return null;
};

const getButtonVariantForProstoyAndSvayzZ = ({
  accumulator,
  services,
  tetheringIsLow,
}: {
  accumulator: EnrichedAccumItemType;
  services: AccumServiceType | undefined;
  tetheringIsLow?: boolean;
}): UnlimitedAccumulatorButtonType | null => {
  const unlimitedVariant = getUnlimitedVariant({ accumulator, services, tetheringIsLow });
  const isUnlimited24Hours = unlimitedVariant === 'Unlimited24Hours';

  if (isUnlimited24Hours && !!services?.unlimited24?.expirationDate) {
    const isNeedToShowButton = isWithinThresholdFromNow({
      dateString: services.unlimited24.expirationDate,
      threshold: { minutes: 15 },
    });

    const hasReplenishmentButton = !!accumulator.replenishButtonType;

    if (!isNeedToShowButton) {
      return null;
    }

    return hasReplenishmentButton ? 'Replenishment' : 'GbForDay';
  }

  return null;
};

export const getUnlimitedAccumulatorButtonType = ({
  accumulator,
  services,
  accumulatorVariant,
  tetheringIsLow,
}: {
  accumulator: EnrichedAccumItemType;
  accumulatorVariant: AccumulatorVariant;
  services: AccumServiceType | undefined;
  tetheringIsLow?: boolean;
}): UnlimitedAccumulatorButtonType | null => {
  return accumulatorVariant === 'base' ?
      getButtonVariantForBaseTariffs({ accumulator, services, tetheringIsLow })
    : getButtonVariantForProstoyAndSvayzZ({ accumulator, services, tetheringIsLow });
};
